import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { alpha } from '@mui/material'

import CustomTabs from '@/views/components/custom-tabs/custom-tabs.component'
import { PersonalizationEngineComponent } from '@/views/personalization-engine'
import { colors } from '@/theme/colors.theme'

import { ApplicationState } from '@/state/root.models'
import {
  BonusWalletsByPlayerComponent,
  ReportsCasinoByPlayerComponent,
  TransactionsByPlayerComponent,
} from '../'
import PersonIcon from '@mui/icons-material/Person'

import CardGiftcardIcon from '@mui/icons-material/CardGiftcard'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import CachedIcon from '@mui/icons-material/Cached'

export const PlayerCardTabsComponent = () => {
  const { t } = useTranslation()

  const { playerCard } = useSelector(
    ({ playerCard }: ApplicationState) => playerCard,
  )

  const tabsArray = [
    {
      id: 0,
      title: t('labels.dashboards'),
      label: 'personalization',
      titleIcon: <PersonIcon />,
      childrenComponent: (
        <PersonalizationEngineComponent
          playerId={playerCard?.id}
          hideSearchByPlayer
        />
      ),
    },
    {
      id: 1,
      title: t('labels.transactions'),
      label: 'transactions',
      titleIcon: <CachedIcon />,
      childrenComponent: <TransactionsByPlayerComponent />,
    },
    {
      id: 2,
      title: t('labels.bonuses'),
      label: 'bonuses',
      titleIcon: <CardGiftcardIcon />,
      childrenComponent: <BonusWalletsByPlayerComponent />,
    },
    {
      id: 3,
      title: t('labels.casinoReports'),
      label: 'casino',
      titleIcon: <DescriptionOutlinedIcon />,
      childrenComponent: <ReportsCasinoByPlayerComponent />,
    },
    // {
    //   id: 4,
    //   title: t('playerCard.responsibleGaming'),
    //   label: 'responsibleGaming',
    //   childrenComponent: <ResponsibleGamingComponent />,
    // },
  ]

  return (
    <CustomTabs
      tabsArray={tabsArray}
      sxPanel={{
        backgroundColor: 'transparent',
        pt: '10px',
        borderTop: `2px solid ${alpha(colors.white, 0.1)}`,
      }}
      sxTab={{
        '& .MuiTab-root': {
          paddingBottom: '15px',
        },
      }}
    />
  )
}
